import { updateLocalStorage, getLocalStorageKey } from '../../shared/customReports/localStorage';
import Routes from '../../routes';

type updateLocalStorageAndPushCustomReportParams = {
  reportSetId: string;
  reportId: string;
  history: {
    push: (route: string) => {};
  };
  periodName: string;
  connName: string;
};

export const updateLocalStorageAndPushCustomReport = ({
  reportSetId,
  reportId,
  history,
  periodName,
  connName,
}: updateLocalStorageAndPushCustomReportParams) => {
  updateLocalStorage({
    keyname: getLocalStorageKey(reportSetId),
    state: {
      params: JSON.stringify({
        [`${reportId}query_period_name`]: periodName,
        [`${reportId}query_conn_name`]: connName,
      }),
    },
  });
  history.push(Routes.reports.CUSTOM_REPORT.replace(/:customReportId/, reportSetId));
};
